import {
  DocumentData,
  DocumentSnapshot,
  FirestoreDataConverter,
  SnapshotOptions,
  WithFieldValue,
} from "firebase/firestore";
import { PaymentHistoryEntry } from "../payroll/paymentHistory";

export const paymentHistoryConverter: FirestoreDataConverter<PaymentHistoryEntry> = {
  toFirestore(entry: WithFieldValue<PaymentHistoryEntry>): DocumentData {
    const { id, ...data } = entry;
    return {
      user_id: data.user_id,
      start: data.start,
      end: data.end,
      paid_at: data.paid_at,
      paid_by: data.paid_by ?? null,
    };
  },
  fromFirestore(
    snapshot: DocumentSnapshot,
    options: SnapshotOptions,
  ): PaymentHistoryEntry {
    const data = snapshot.data(options);
    return {
      id: snapshot.id,
      user_id: typeof data?.user_id === "string" ? data.user_id : "",
      start: typeof data?.start === "string" ? data.start : "",
      end: typeof data?.end === "string" ? data.end : "",
      paid_at: typeof data?.paid_at === "string" ? data.paid_at : "",
      paid_by: typeof data?.paid_by === "string" ? data.paid_by : undefined,
    };
  },
};
